/**
 * TO USE THIS: 
 * Call 'openStrapModal()' in your theme's 'Add to Cart' success function.
 */
let selectedStraps = [];

function openStrapModal() {
  const modal = document.getElementById('strap-modal');
  const grid = document.getElementById('strap-grid');
  // Clear and Reset
  grid.innerHTML = '';
  selectedStraps = [];
  updateFooterButton();
  // Assuming all_free_straps is globally available in your JS
  if (typeof all_free_straps !== 'undefined' && all_free_straps.length > 0) {
    all_free_straps.forEach(strap => {
      const item = document.createElement('div');
      item.className = 'strap-item';
      item.innerHTML = `
        <img src="${strap.img}" alt="${strap.product_title}">
        <span class="strap-label">${strap.product_title}</span>
        <button class="select-btn btn btn--full btn--secondary" data-id="${strap.id}">SELECT</button>
      `;
      grid.appendChild(item);
    });
    modal.classList.add('model-visible');
    initSelectionLogic();
  } else {
    console.error("No free straps found in all_free_straps variable.");
  }
}
function initSelectionLogic() {
  const btns = document.querySelectorAll('.select-btn');
  btns.forEach(btn => {
    btn.addEventListener('click', function() {
      const id = this.getAttribute('data-id');
      if (selectedStraps.includes(id)) {
        // Remove selection
        selectedStraps = selectedStraps.filter(s => s !== id);
        this.classList.remove('selected');
        this.innerText = 'SELECT';
      } else {
        // Add selection (Max 2)
        if (selectedStraps.length < 2) {
          selectedStraps.push(id);
          this.classList.add('selected');
          this.innerText = 'SELECTED';
        } else {
        }
      }
      updateFooterButton();
    });
  });
}
function updateFooterButton() {
  const addBtn = document.getElementById('add-straps-to-cart');
  const counterPill = document.getElementById('strapCounter');
  const count = selectedStraps.length;
  // Update the Pill Text
  if (counterPill) {
    counterPill.innerText = `${count}/2 Free Straps Selected`;
  }
  if (count === 2) {
    addBtn.disabled = false;
    addBtn.innerText = "ADD STRAPS TO CART";
  } else {
    addBtn.disabled = true;
    addBtn.innerText = `SELECT ${2 - count} MORE STRAP${count === 1 ? '' : 'S'}`;
  }
}
function closeStrapModal() {
    document.getElementById('strap-modal').classList.remove('model-visible');
    setTimeout(() => {
        var cart = new theme.CartDrawer;
        cart.init();
        cart.open();        
    }, 500);
    const counterPill = document.getElementById('strapCounter');
    if (counterPill) {
        counterPill.innerText = "0/0 Free Straps Selected";
    }
}
// Final Submission
document.getElementById('add-straps-to-cart').addEventListener('click', function(e) {
  e.preventDefault();
  const btn = this;
  btn.classList.add('btn--loading');
  const items = selectedStraps.map(id => ({
    id: parseInt(id),
    quantity: 1
  }));
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(res => res.json())
  .then(data => {
    document.getElementById('strap-modal').classList.remove('model-visible');
    btn.classList.remove('btn--loading');
    var cart = new theme.CartDrawer;
    cart.init();
    cart.open();
  })
  .catch(err => console.error("Cart Error:", err));
});
// Close Modal
document.querySelector('.close-modal').addEventListener('click', () => {
    closeStrapModal();
});
// Close if clicking outside the box
window.addEventListener('click', (e) => {
  const modal = document.getElementById('strap-modal');
  if (e.target === modal) modal.classList.remove('model-visible');
});
document.querySelector('[data-new-atc]')?.addEventListener('click', function(e) {
  const btn = this;
  e.preventDefault(); 
  // 1. Grab the ID directly from the data attribute
  const mainVariantId = this.getAttribute('data-variant-id');
  if (!mainVariantId) {
    console.error("Variant ID missing from button attribute.");
    return;
  }
  // Optional: Visual feedback for the user
  const btnSpan = this.querySelector('[data-add-to-cart-text]');
  btn.classList.add('btn--loading');
  this.style.pointerEvents = 'none'; // Prevent double-clicks
  openStrapModal();
  // 2. Add the main product to cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: parseInt(mainVariantId),
        quantity: 1
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    // Reset button state
    btn.classList.remove('btn--loading');
    this.style.pointerEvents = 'auto';
    // 3. Open the gift modal
  })
  .catch(error => {
    console.error('Error:', error);
    btn.classList.remove('btn--loading');
    this.style.pointerEvents = 'auto';
  });
});
// 1. Target the element you want to place the banner before
const targetElement = document.querySelector('[data-new-atc]');
// 2. Define the HTML structure
var promoBanner = `
<section class="atc-promo-banner">
  <div class="atc-inner-container">
    <h2>TWO FREE STRAPS & KEYRING WITH EVERY BAG</h2>
    <ol>
      <li>Choose your bag</li>
      <li>Choose any 2 straps <a href="/collections/straps">HERE</a></li>
      <li>DISCOUNT AUTOMATICALLY APPLIED AT CHECKOUT</li>
    </ol>
  </div>
</section>
`;
const text = document.querySelector('#AnnouncementSlider').innerText;
// Regex breakdown: 
// /WORTH\s+([^\s]+)/i
// WORTH  -> matches the word
// \s+    -> matches one or more spaces
// ([^\s]+) -> captures everything that isn't a space (the value)
// i      -> case insensitive flag
const match = text.match(/WORTH\s+([^\s]+)/i);
if (match) {
  const worthValue = match[1]; 
  promoBanner = `
    <section class="atc-promo-banner">
    <div class="atc-inner-container">
        <h2>TWO FREE STRAPS & KEYRING WITH EVERY BAG WORTH ${worthValue}</h2>
        <ol>
        <li>Choose your bag</li>
        <li>Choose any 2 straps <a href="/collections/straps">HERE</a></li>
        <li>DISCOUNT AUTOMATICALLY APPLIED AT CHECKOUT</li>
        </ol>
    </div>
    </section>
    `;
}
// 3. Insert it "beforebegin" (just before the target element)
if (targetElement) {
  targetElement.insertAdjacentHTML('beforebegin', promoBanner);
} else {
  console.warn("Target element [data-new-atc] not found on the page.");
}
